import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/menuIcons/person-plus.svg'


const _hoisted_1 = { class: "row" }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "row gap-04" }
const _hoisted_4 = { class: "pwr-btn-container" }
const _hoisted_5 = {
  key: 1,
  class: "pad-s h-48 item-center"
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "row gap-04" }
const _hoisted_8 = { class: "pwr-btn-container" }
const _hoisted_9 = {
  key: 1,
  class: "colCenter marg-s"
}
const _hoisted_10 = {
  key: 2,
  class: "pad-s"
}
const _hoisted_11 = { class: "main-m font-m new-id-width" }
const _hoisted_12 = { class: "main-h font-m mleft-02" }
const _hoisted_13 = {
  key: 0,
  class: "main-alert font-m mleft-06"
}
const _hoisted_14 = {
  key: 4,
  class: "row pad-s pleft-06"
}

import { ref, computed, onMounted, onUnmounted, nextTick } from 'vue';
import { useI18n } from 'vue-i18n';
import addPatientForm from '@/components/form/addPatientForm.vue';
import loadingSpinner from '@/views/loadingSpinner.vue';
import { formatMatricule, getDigits, getFormattedCnsPrefixForPwr } from '@/functions/lu.js';
import EsButtonIcon from '@/components/esButtonIcon.vue';
import { useCurrentEntryStore } from '@/stores/currentEntry';
import { useUiStore } from '@/stores/ui';
import { useRouter } from 'vue-router';
import { apiDateString } from '@/api/apicommon';
import { useHistorySearchPatientStore } from '@/stores/historySearchPatient';
import { useAppUserStore } from '@/stores/appUser';
import { PatientSearchApi, SearchPatientRequest } from '@/apiGenerate/medserver';
import { medServerApiConfig } from '@/config/medserver-api.config';
import { useDebounceFn } from '@vueuse/core';
import { toastWarn } from '@/utils/toast-utils';
import { useToast } from 'primevue';
import PersonService from "@/services/PersonService";
import { getInvalidSsnMessage, isValidBirthDateOrSsn } from '@/utils/ssn-utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'patientSearch',
  props: {
  fastPatientCreation: {
    type: Boolean,
    default: false,
  }
},
  emits: ["modal-close"],
  setup(__props, { emit: __emit }) {

const toast = useToast();

const props = __props;

const useFastCreate = ref(false);

const patientApi = new PatientSearchApi(medServerApiConfig);

const allPatientList = ref([]);
const loadPatient = ref(false);
const searchInput = ref("");
const lastSearchInput = ref("");
const pwrFoundPatientsHistory = ref([]);
const dropd = ref("");
const uiStore = useUiStore();
const currentEntryStore = useCurrentEntryStore();
const historySearchPatientStore = useHistorySearchPatientStore();
const router = useRouter();
const appUserStore = useAppUserStore();
const { t } = useI18n();

const emit = __emit;

const healthGroupMembershipsUuid = computed(() => {
  if (!appUserStore.currentAppUserData) {return []}
  return appUserStore.currentAppUserData.healthGroupMemberships.map((healthGroupMemberships: any) => healthGroupMemberships.instituteWithRole?.instituteWithRoleId);
})

function setNewPatient() {
  nextTick(() => {
    dropd.value = "AddNewPatient"
  })
}

const clipboardText = ref("");
const setNewPatientFastCreate = async () => {
  const text = await navigator.clipboard.readText();

  if (!text || text.trim().length === 0) {
    toastWarn(toast, {
      summary: t('patient.create.toast.emptyClipboard'),
      detail: t('patient.create.toast.emptyClipboardDetail'),
      life: 5000
    });
    return;
  }
  clipboardText.value = text;
  useFastCreate.value = true;
  setNewPatient();
}

function addPwrFoundPatientToList(pwrPatient: any){
  const maxHistory = 5
  // Remove the same patient from history if needed
  const index = pwrFoundPatientsHistory.value.findIndex(
      (patient) => patient.personWithRoleId === pwrPatient.personWithRoleId
  )
  if (index !== -1) {
    pwrFoundPatientsHistory.value.splice(index, 1)
  }
  // Add at the beginning
  pwrFoundPatientsHistory.value.unshift(pwrPatient)
  // Limit the number of items
  if (pwrFoundPatientsHistory.value.length > maxHistory) {
    pwrFoundPatientsHistory.value = pwrFoundPatientsHistory.value.slice(0, maxHistory);
  }
  historySearchPatientStore.setHistoryData(pwrFoundPatientsHistory.value);
}

const debouncedInputFct = useDebounceFn(() => {
  inputFct()
}, 300);

function handleNewPatientId(searchValue: string, allPatients: any) {
  if (loadPatient.value) return;
  // Compute ID-related values
  const idDigits = getDigits(searchValue);
  const formattedIdDigits = formatMatricule(idDigits);
  newId.value = idDigits;
  newIdFormatted.value = formattedIdDigits;
  const invalidMatriculeMsg = getInvalidSsnMessage(idDigits);
  invalidIdMsg.value = invalidMatriculeMsg ? t(invalidMatriculeMsg) : "";
  // Auto-open new patient dialog if conditions are met
  if (!invalidMatriculeMsg && idDigits.length === 13 && allPatients.length === 0) {
    protectedNewId.value = idDigits;
    protectedNewIdFormatted.value = formattedIdDigits;
    setNewPatient();
  }
}

function openNewPatientFromMatricule() {
  if (!isCreatableNewPatient.value) return;
  protectedNewId.value = newId.value;
  protectedNewIdFormatted.value = newIdFormatted.value;
  setNewPatient();
}

function isNumericSearch(searchValue: string) {
  return /^\d+$/.test(searchValue.replace(/\s+/g, ''));
}

const abortController = ref<AbortController | null>(null);

async function performSearch(searchValue: string) {
  if (searchValue.length <= 2) return [];
  //AbortController
  if (abortController.value) {
    abortController.value.abort();
  }
  abortController.value = new AbortController();
  const signal = abortController.value.signal;

  loadPatient.value = true;
  try {
    const searchPatientRequest: SearchPatientRequest = {
      institutes: healthGroupMembershipsUuid.value
    }
    const results = await patientApi.searchPatient({ search: searchValue, searchPatientRequest: searchPatientRequest }, { signal });
    if (signal.aborted) return [];
    // Sort numeric searches by CNS affiliation number
    if (isNumericSearch(searchValue)) {
      results.sort((a, b) => a.cnsAffiliationNumber?.localeCompare(b?.cnsAffiliationNumber));
    }
    // For text searches, keep backend ordering
    return results;
  } catch (error) {
    const isAbort = error instanceof DOMException && error.name === 'AbortError';
    if (!isAbort) console.error('Patient search failed:', error);
    return [];
  } finally {
    if (!signal.aborted) loadPatient.value = false;
  }
}

async function inputFct() {
  let searchValue = searchInput.value.trim();
  if (isOnlyDigits.value) {
    searchValue = searchValue.replace(/[^0-9]/g, '');
  }
  const results = await performSearch(searchValue);
  lastSearchInput.value = searchValue;
  allPatientList.value = results;
  handleNewPatientId(searchValue, results);
}

const invalidIdMsg = ref("")
const newIdFormatted = ref("")
const protectedNewIdFormatted = ref("")
const newId = ref("")
const protectedNewId = ref("")


const redirectCalendar = async (newPatient: any) => {
  dropd.value = "";
  accessCalendar(newPatient);
};

async function setNewPatientFct(pwrNewPatient: any) {
  dropd.value = "";
  searchInput.value = ""

  if (props.fastPatientCreation) {
    emit('modal-close');
  }

  if (!pwrNewPatient) return;
  openModalPatient(pwrNewPatient, 'patientAdmin');
}

const isOnlyDigits = computed(() => {
  const regex = /^[\d\s]*$/
  return (regex.test(searchInput.value))
})

const isExistingPatient = computed(() => {
  return (invalidIdMsg.value === "" && newId.value.length === 13 && allPatientList.value.length > 0)
})

function getPwrFullName(pwr: any) {
  return pwr ? PersonService.formatName(pwr.lastName, pwr.firstName) : '';
}

function getCns(pwr) {
  const cnsPrefix = getFormattedCnsPrefixForPwr(pwr)
  const cnsSuffix = pwr.cnsHealthInsurance?.cnsSuffix
  const cnsNumber = pwr.cnsAffiliationNumber
    ? cnsPrefix + " " + cnsSuffix
    : cnsPrefix

  return pwr.cnsAffiliationNumber ? pwr.cnsAffiliationNumber.slice(0,8) + ' ' + pwr.cnsAffiliationNumber.slice(8) : cnsNumber
}

async function accessCalendar(pwrPatient: any) {
  setLoadingScreenTexts(pwrPatient);
  addPwrFoundPatientToList(pwrPatient);

  await currentEntryStore.setCurrentPatientCalendar(pwrPatient);

  emit('modal-close');

  router.push({
    name: "calendar"
  });
}

async function accessPatient(pwrPatient: any) {
  setLoadingScreenTexts(pwrPatient);

  addPwrFoundPatientToList(pwrPatient);
  if (pwrPatient.personWithRoleId !== currentEntryStore.currentPatientId) {
    currentEntryStore.clearCurrentEntry();
  }
  openEntry(pwrPatient);
    
}

async function openModalPatient(pwrPatient: any, keyword: string) {
  const patientId = pwrPatient.personWithRoleId;
  addPwrFoundPatientToList(pwrPatient);
  emit('modal-close');
  currentEntryStore.openPatientModal(keyword);
  await currentEntryStore.setModalPatient(patientId);
}

function setLoadingScreenTexts(pwrPatient: any) {
  const loadingText = PersonService.formatName(pwrPatient.lastName, pwrPatient.firstName);
  const loadingSubText = apiDateString(pwrPatient.birthDate);
  uiStore.setLoadingScreenText(loadingText);
  uiStore.setLoadingScreenSubText(loadingSubText);
}

const isCreatableNewPatient = computed(() => {
  if (!isOnlyDigits.value) return false;
  const len = newId.value.length;
  if (len !== 8 && len !== 13) return false;
  // Date must be valid; checksum may or may not be
  return isValidBirthDateOrSsn(newId.value);
});

async function openEntry(pwrPatient: any) {

  emit('modal-close');

  router.push({
    name: "patient",
    params: { patientId: pwrPatient.personWithRoleId }
  });
}

onMounted(async () => {
  pwrFoundPatientsHistory.value = historySearchPatientStore.history;
})

onUnmounted(() => {
  abortController.value?.abort();
});


return (_ctx: any,_cache: any) => {
  const _component_dropdownBox = _resolveComponent("dropdownBox")!
  const _component_svg_item = _resolveComponent("svg-item")!
  const _component_text_item = _resolveComponent("text-item")!
  const _component_listGroup = _resolveComponent("listGroup")!
  const _component_inputComboBox2 = _resolveComponent("inputComboBox2")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_inputComboBox2, {
      ref: "searchInputRef",
      class: "w-full",
      modelValue: searchInput.value,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((searchInput).value = $event)),
      onInput: _cache[5] || (_cache[5] = ($event: any) => (_unref(debouncedInputFct)())),
      autoFocus: true
    }, {
      pre: _withCtx(() => [
        _createVNode(_component_dropdownBox, {
          modelValue: dropd.value,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((dropd).value = $event)),
          openOn: "AddNewPatient"
        }, {
          dropd: _withCtx(() => [
            _createVNode(addPatientForm, {
              "fast-patient-creation": useFastCreate.value,
              clipboardText: clipboardText.value,
              newId: protectedNewId.value,
              newIdFormatted: protectedNewIdFormatted.value,
              onAfterPatientCreated: setNewPatientFct,
              onRedirectCalendar: _cache[0] || (_cache[0] = ($event: any) => (redirectCalendar($event)))
            }, null, 8, ["fast-patient-creation", "clipboardText", "newId", "newIdFormatted"])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      dropd: _withCtx(() => [
        (!searchInput.value.trim().length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (pwrFoundPatientsHistory.value.length > 0)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(pwrFoundPatientsHistory.value, (pwrPatient, index) => {
                    return (_openBlock(), _createBlock(_component_listGroup, {
                      key: index,
                      class: "pos-r"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "col w-full pad-m pleft-06 h-48 justify-center",
                          onClick: ($event: any) => (openModalPatient(pwrPatient, ''))
                        }, [
                          _createElementVNode("div", _hoisted_3, [
                            _createVNode(_component_svg_item, {
                              icon: "clock",
                              styles: "size-m main-m"
                            }),
                            _createVNode(_component_text_item, {
                              txt: getPwrFullName(pwrPatient)
                            }, null, 8, ["txt"]),
                            _createVNode(_component_text_item, {
                              txt: getCns(pwrPatient),
                              styles: "main-m font-size-16"
                            }, null, 8, ["txt"])
                          ])
                        ], 8, _hoisted_2),
                        _createElementVNode("div", _hoisted_4, [
                          _createVNode(EsButtonIcon, {
                            styles: "img-grey square-16",
                            buttonStyles: "flex-square-29",
                            icon: "stethoscope",
                            folder: "shareIcons",
                            onClick: ($event: any) => (accessPatient(pwrPatient))
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createVNode(_component_text_item, {
                      class: "mleft-04",
                      txt: _unref(t)('patient.search.placeholder'),
                      styles: "main-l"
                    }, null, 8, ["txt"])
                  ]))
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (allPatientList.value.length)
                ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(allPatientList.value, (pwrPatient, index) => {
                    return (_openBlock(), _createBlock(_component_listGroup, {
                      key: index,
                      class: "pos-r"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", {
                          class: "col w-full pad-m pleft-06 h-48 justify-center",
                          onClick: ($event: any) => (openModalPatient(pwrPatient, ''))
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createVNode(_component_text_item, {
                              txt: getPwrFullName(pwrPatient)
                            }, null, 8, ["txt"]),
                            _createVNode(_component_text_item, {
                              txt: getCns(pwrPatient),
                              styles: "main-m"
                            }, null, 8, ["txt"])
                          ])
                        ], 8, _hoisted_6),
                        _createElementVNode("div", _hoisted_8, [
                          _createVNode(EsButtonIcon, {
                            styles: "img-grey square-16",
                            buttonStyles: "flex-square-29",
                            icon: "stethoscope",
                            folder: "shareIcons",
                            onClick: ($event: any) => (accessPatient(pwrPatient))
                          }, null, 8, ["onClick"])
                        ])
                      ]),
                      _: 2
                    }, 1024))
                  }), 128))
                : (loadPatient.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                      _createVNode(loadingSpinner, {
                        logo: false,
                        style: 'w-3'
                      })
                    ]))
                  : (!newId.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createVNode(_component_text_item, {
                          class: "mleft-04",
                          txt: _unref(t)('patient.search.noResult'),
                          styles: "main-l"
                        }, null, 8, ["txt"])
                      ]))
                    : _createCommentVNode("", true),
              (isCreatableNewPatient.value && !isExistingPatient.value && !loadPatient.value)
                ? (_openBlock(), _createBlock(_component_listGroup, {
                    key: 3,
                    styles: "pad-s",
                    class: "pleft-06",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (openNewPatientFromMatricule()))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_11, _toDisplayString(newIdFormatted.value), 1),
                      _createElementVNode("span", _hoisted_12, _toDisplayString(_unref(t)('patient.search.new')), 1),
                      (invalidIdMsg.value)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, _toDisplayString(invalidIdMsg.value), 1))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : (newId.value.length && isOnlyDigits.value && !loadPatient.value && !isExistingPatient.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_text_item, {
                        txt: newIdFormatted.value,
                        styles: "main-m",
                        class: "new-id-width"
                      }, null, 8, ["txt"]),
                      _createVNode(_component_text_item, {
                        txt: invalidIdMsg.value,
                        styles: "main-l",
                        class: "mleft-04"
                      }, null, 8, ["txt"])
                    ]))
                  : _createCommentVNode("", true)
            ], 64)),
        (props.fastPatientCreation)
          ? (_openBlock(), _createBlock(_component_listGroup, {
              key: 2,
              styles: "pad-m",
              class: "rowcenter",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (setNewPatientFastCreate()))
            }, {
              default: _withCtx(() => [
                _cache[6] || (_cache[6] = _createElementVNode("img", {
                  class: "square-14 img-primary",
                  src: _imports_0,
                  alt: 'layout.patient'
                }, null, -1)),
                _createVNode(_component_text_item, {
                  txt: _unref(t)('patient.create.form.importCreate'),
                  styles: "font-m",
                  class: "mleft-03 txt-primary"
                }, null, 8, ["txt"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})